import React from 'react';
import { compose, withProps } from 'recompose';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow,
} from 'react-google-maps';
import Constants from '../../config/constants';

class Map extends React.Component {
  constructor(props) {
    super(props);
    const { marker } = props;

    this.state = {
      marker: {
        center: {
          lat: marker.lat,
          lng: marker.lng,
        },
        name: marker.name,
        icon: marker.icon,
        isShowInfo: false,
        isMovedByUser: false,
      },
    };

    this.mapRef = null;
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.forcedRedrawMarker && this.state.marker.isMovedByUser) {
      return;
    }

    const { marker } = nextProps;
    this.setState({
      marker: {
        center: {
          lat: marker.lat,
          lng: marker.lng,
        },
        name: marker.name,
        icon: marker.icon,
      },
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.marker.lat !== prevState.marker.center.lat || this.state.marker.lng !== prevState.marker.center.lng) {
      this.mapRef.panTo(new window.google.maps.LatLng(this.state.marker.center.lat, this.state.marker.center.lng));
    }
  }

  toggleMarker() {
    this.setState({ isShowInfo: !this.state.isShowInfo });
  }

  pinMarker({ latLng }) {
    if (this.props.editable) {
      this.updateMarker(latLng.lat(), latLng.lng());
    }
  }

  updateMarker(lat, lng) {
    this.setState({
      marker: {
        ...this.state.marker,
        center: { lat, lng },
        isMovedByUser: true,
      },
    });

    if (this.props.onMarkerMoved) {
      this.props.onMarkerMoved(lat, lng);
    }
  }

  renderMarker({ center, name, icon }, draggable) {
    const { lat, lng } = center;
    return (
      <Marker
        position={{ lat, lng }}
        icon={icon}
        onClick={() => this.toggleMarker()}
        onDragEnd={({ latLng }) => this.updateMarker(latLng.lat(), latLng.lng())}
        draggable={draggable}
      >
        {this.state.isShowInfo && <InfoWindow onCloseClick={() => this.toggleMarker()}><h4>{name}</h4></InfoWindow>}
      </Marker>
    );
  }

  render() {
    const { marker } = this.state;
    const isShowMap = marker ? marker.center.lat !== null && marker.center.lng !== null : false;

    let attr = {
      ref: (ref) => {
        this.mapRef = ref;
      },
      defaultZoom: Constants.MAP_ZOOM_LEVEL,
      defaultCenter: {
        lat: Constants.MAP_CENTER_LAT,
        lng: Constants.MAP_CENTER_LNG,
      },
      defaultOptions: {
        gestureHandling: 'cooperative',
      },
      onClick: this.pinMarker.bind(this),
    };

    if (isShowMap && !marker.isMovedByUser) {
      attr = {
        ...attr,
        defaultCenter: marker.center,
      };
    }

    return (
      <GoogleMap {...attr}>
        {isShowMap ? this.renderMarker(marker, this.props.editable) : null}
      </GoogleMap>
    );
  }
}

export default compose(
  withProps({
    googleMapURL: (() => {
      const url = `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places`;
      return url + (Constants.MAP_KEY ? `&key=${Constants.MAP_KEY}` : '');
    })(),
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `235px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap,
)(props => <Map {...props} />);



// WEBPACK FOOTER //
// ./src/components/map/Map.js